import React from "react";
import { navItems } from "src/utils/constants";
import { Button } from "src/components/ui/Button";
import BlogSection from "src/components/sections/BlogSection";
import TeamSection from "src/components/sections/TeamSection";
import StorySection from "src/components/sections/StorySection";
import StatisticsSection from "src/components/sections/StatisticsSection";
import IntroductionSection from "src/components/sections/IntroductionSection";
import CallToActionSection from "src/components/sections/CallToActionSection";

import logoImage from "src/assets/logoShape.png";

import "./About.scss";

export const About = () => {
  return (
    <div className="about">
      <div className="about__header">
        <div className="about__container">
          <nav className="about__nav">
            <div className="about__logo-container">
              <div className="about__logo">
                <img src={logoImage} alt="Boldo logo" />
              </div>
              <span className="about__brand-name">Boldo</span>
            </div>

            <div className="about__nav-items">
              {navItems.map((item, index) => (
                <label key={index} className="about__nav-item">
                  {item.label}
                </label>
              ))}
              <Button className="about__login-button" variant="themed-outline">
                <span className="about__login-text">Log In</span>
              </Button>
            </div>
          </nav>
        </div>

        <IntroductionSection />
      </div>
      <StatisticsSection />
      <StorySection />
      <TeamSection />
      <BlogSection />
      <CallToActionSection />
    </div>
  );
};
